// extracted by mini-css-extract-plugin
module.exports = {"home-page-header":"home-page-header__3n-Qk","splitter":"splitter__1VunM","reservables":"reservables__1Rxvl","button":"button__2PAe0"};